"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_browser_languagedetector_1 = require("i18next-browser-languagedetector");
var changeLocale_1 = require("./changeLocale");
var locale_1 = require("./locale");
var translationMetadata_1 = require("./utils/translationMetadata");
var defaultDetectorOptions = {
    // order and from where user language should be detected
    order: ['querystring', 'cookie', 'localStorage', 'navigator'],
    // keys or params to lookup language from
    lookupQuerystring: 'intl',
    lookupLocalStorage: 'i18nextLng',
    lookupCookie: 'dd_language',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
    // cache user language on
    caches: ['cookie', 'localStorage'],
    // languages to not persist (cookie, localStorage)
    excludeCacheFor: ['cimode'],
};
function i18nAppProvider(i18nextInstance) {
    return {
        initialize: function (options) {
            var customDetector = options.customDetector, _a = options.detectorOptions, detectorOptions = _a === void 0 ? {} : _a, onInit = options.onInit, _b = options.fallbackLocale, fallbackLocale = _b === void 0 ? locale_1.Locale.EN_US : _b, localizedStrings = options.localizedStrings;
            var languageDetector = new i18next_browser_languagedetector_1.default();
            // tslint:disable-next-line: strict-boolean-expressions
            if (customDetector) {
                languageDetector.addDetector(customDetector);
            }
            var whitelist = [];
            var resources = Object.entries(localizedStrings).reduce(function (p, _a) {
                var _b;
                var _c = __read(_a, 2), locale = _c[0], localizedStringMap = _c[1];
                whitelist.push(locale);
                return __assign(__assign({}, p), (_b = {}, _b[locale] = {
                    translation: localizedStringMap,
                }, _b));
            }, {});
            i18nextInstance
                // detect user language
                // https://github.com/i18next/i18next-browser-languageDetector
                .use(languageDetector);
            // https://www.i18next.com/overview/configuration-options
            i18nextInstance.init({
                resources: resources,
                whitelist: whitelist,
                debug: false,
                detection: __assign(__assign({}, defaultDetectorOptions), detectorOptions),
                fallbackLng: fallbackLocale,
                interpolation: {
                    escapeValue: false, // not needed for react as it escapes by default
                },
            }, onInit);
        },
        changeLocale: function (locale) {
            return (0, changeLocale_1.default)(i18nextInstance, locale).then(function () {
                window.location.reload();
            });
        },
        getCurrentLocale: function () {
            return i18nextInstance.language;
        },
        /**
         * Wrapper method that accounts for translations contained within
         * metadata objects (under a "value" property).
         *
         * IMPROVE: @brooks-dd Simplify translation method to lookup only by key
         * once translations are only generated as basic string key-value pairs
         * JIRA ticket: https://doordash.atlassian.net/browse/I18NL-235
         */
        translate: function (key, config) {
            return i18nextInstance.t([key + "." + translationMetadata_1.VALUE, key], config);
        },
    };
}
exports.default = i18nAppProvider;
